import { enUS, ko } from "date-fns/locale";
import { useTranslation } from "react-i18next";

/**
 * react-datepicker(달력)의 요일·월 표기를 현재 언어에 맞춰 반환한다.
 * `?lang=en` 이면 영문(enUS), 그 외에는 한국어(ko).
 */
export const useDatePickerLocale = () => {
  const { i18n } = useTranslation();
  return i18n.language?.startsWith("en") ? enUS : ko;
};
